class SizeCount {
  static KbCountBig (type, long, wide) {
    const zlong = type === 1 ? 1194 : 1092
    const zwide = type === 1 ? 889 : 787
    // 排列1
    const col = Number.parseInt(zlong / long)
    const row = Number.parseInt(zwide / wide)
    const childRow = Number.parseInt(zlong % long / wide)
    const childCol = Number.parseInt(zwide / long)
    const oneCount = row * col + childCol * childRow
    // 排列2
    const twoCol = Number.parseInt(zlong / wide)
    const twoRow = Number.parseInt(zwide / long)
    const twoChildRow = Number.parseInt(zwide % long / wide)
    const twoChildCol = Number.parseInt(zlong / long)
    const twoCount = twoRow * twoCol + twoChildRow * twoChildCol
    // 设置返回对象
    let kb = {}
    if (oneCount >= twoCount) {
      kb = {
        type: 1,
        count: oneCount,
        row: row,
        col: col,
        childCol: childCol,
        childRow: childRow
      }
    } else {
      kb = {
        type: 2,
        count: twoCount,
        row: twoRow,
        col: twoCol,
        childCol: twoChildCol,
        childRow: twoChildRow
      }
    }
    return kb
  }
  // 计算绸布,返回实际需要米数
  static drapery (long, wide, quantity) { // 长、宽、数量
    const draperyWide = 1500// 宽幅常量
    if (draperyWide % long > draperyWide % wide) {
      const t = draperyWide / wide
      return quantity / t * long / 1000
    } else {
      const t = draperyWide / long
      return quantity / t * wide / 1000
    }
  }
  // 计算纸箱
  static carton (clong, cwide, cheight, long, wide, height) {
    const mlong = clong % long
    const mwide = clong % wide
    // let mheight = clong % height
    let re
    if (mlong > mwide) {
      const a = parseInt(clong / wide)
      const b = parseInt(cwide / long)
      const c = parseInt(cheight / height)
      re = a * b * c
    } else {
      const a = parseInt(clong / long)
      const b = parseInt(cwide / wide)
      const c = parseInt(cheight / height)
      re = a * b * c
    }
    const mmwide = cwide % long
    let ree
    if (mlong > mmwide && cheight > height) {
      const a = parseInt(clong / height)
      const b = parseInt(cwide / long)
      const c = parseInt(cheight / wide)
      ree = a * b * c
    } else {
      const a = parseInt(clong / long)
      const b = parseInt(cwide / height)
      const c = parseInt(cheight / wide)
      ree = a * b * c
    }
    return re > ree ? re : ree
  }
  // 盒型展开图绘制
  static TopBottomdDevelopment (name, olong, owide, oheight, typeName) {
    const canvas = document.getElementById(name)
    const cxt = canvas.getContext('2d')
    const [long, wide, height] = [olong / 2, owide / 2, oheight / 2]
    // 清除画布
    cxt.clearRect(0, 0, olong, owide)
    cxt.strokeRect(height, height, long, wide) // 绘制中心矩形
    cxt.strokeRect(long + height, height, height, wide) // 绘制右矩形
    cxt.strokeRect(height, wide + height, long, height) // 绘制下矩形
    cxt.strokeRect(0, height, height, wide) // 绘制左矩形
    cxt.strokeRect(height, 0, long, height) // 绘制上矩形
    // 绘制文字
    cxt.font = '12px Arial'
    cxt.fillText(olong + 'mm', long / 2, height + 10)
    cxt.fillText(owide + 'mm', height + 10, wide / 2)
    cxt.fillText(oheight + 'mm', long + height + 10, height / 2)
    cxt.font = '20px Arial'
    cxt.fillText(typeName, long / 2, wide + height * 2 + 20) // 名称
  }
  static KBCanvas (elementById, olong, owide, type) {
    const canvas = document.getElementById(elementById)
    const cxt = canvas.getContext('2d')
    const offSet = 80
    // 清除画布
    cxt.clearRect(0, 0, 350, 300)
    // 设置纸张大小
    const [paperLong, paperWide] = type === 1 ? [1194, 889] : [1092, 787]
    cxt.font = '12px Arial'
    cxt.strokeStyle = '#0000ff'
    // `Hello ${name}, how are you ${time}?`
    cxt.fillText(`长=${paperLong}mm`, 165 + offSet, 160 + offSet)
    cxt.fillText(`宽=${paperWide}mm`, 210 + offSet, 135 + offSet)
    const kb = this.KbCountBig(type, olong, owide)
    const [long, wide] = [olong / 6, owide / 6]
    if (kb.type === 1) {
      let inXPoint // 记录附加行列起始点
      // 绘制行列
      for (let row = 0; row < kb.row; row++) {
        for (let col = 0; col < kb.col; col++) {
          inXPoint = (col + 1) * long + offSet
          cxt.strokeRect(col * long + offSet, row * wide + offSet, long, wide)
        }
      }
      // 绘制文字说明
      cxt.font = '14px Arial'
      cxt.fillText(`${olong}mm*${kb.col}K`, 90, offSet - 10)
      cxt.fillText(`${owide}mm*${kb.row}K`, 0, 90 + offSet)
      // 绘制附加行列
      for (let row = 1; row <= kb.childRow; row++) {
        for (let col = 0; col < kb.childCol; col++) {
          cxt.strokeRect(inXPoint * row, col * long + offSet, wide, long)
        }
      }
      // 附加行列文字说明
      if (kb.childRow) {
        // cxt.fillText(`${wide}mm*${kb.childRow}K`, 90, offSet - 10)
        cxt.fillText(`${olong}mm*${kb.childCol}K`, 210 + offSet, offSet + 50)
      }
      // kb.childRow > 0 ? `${wide}mm*${kb.childRow}K` ? ''
    } else {
      let inYPoint // 记录附加行列起始点
      // 绘制行列
      for (let row = 0; row < kb.row; row++) {
        for (let col = 0; col < kb.col; col++) {
          inYPoint = (row + 1) * long
          cxt.strokeRect(col * wide + offSet, row * long + offSet, wide, long)
        }
      }
      // 绘制附加行列
      for (let row = 1; row <= kb.childRow; row++) {
        for (let col = 0; col < kb.childCol; col++) {
          cxt.strokeRect(col * long + offSet, inYPoint * row + offSet, long, wide)
        }
      }
    }
    // 绘制纸张大小
    cxt.strokeStyle = '#000'
    cxt.strokeRect(offSet, offSet, paperLong / 6, paperWide / 6)
    // 总开数
    cxt.font = '20px Arial'
    cxt.fillText('总开数:' + kb.count + 'K', 70 + offSet, 180 + offSet)
    cxt.fillText(type ? '大度' : '正度', 150, 20)
  }
}

export default SizeCount
